import { useCallback } from 'react'
import { refreshProductFiles, useProductDetailStore } from 'sfportal_stores/productDetailStore'
import { useAddSubscriptionToArea } from '../../../../hooks/useAddSubscriptionToArea'
import { useTranslation } from 'react-i18next'
import { useUserStore } from 'sfportal_stores/userStore'
import { useAlert } from 'react-alert'

export function useSubscriptionsForTabContents (): void {
  const { t } = useTranslation()
  const { product } = useProductDetailStore()
  const { currentUser } = useUserStore()
  const alert = useAlert()

  const historicProcessInstanceEndCallback = useCallback((message) => {
    const messageBody = JSON.parse(message.body)
    if (
      messageBody.processdefinitionkey === 'simpleUpload' &&
      currentUser?.id === messageBody.startUserId
    ) {

      let noSfidInFile = messageBody.additionalParameters?.noSfidInFile ?? false;

      if (noSfidInFile) {
          alert.error(t('upload.error.noSFID'))
      } else {
        if (product !== null) {
          refreshProductFiles(product.id)
        }

        alert.show(t('upload.success'))
      }
    }
  }, [alert, currentUser, product, t])

  useAddSubscriptionToArea(
    'historicprocessinstance',
    'end',
    '*',
    historicProcessInstanceEndCallback,
    'workflow'
  )
}
